import styled from "styled-components";

export const Heading1 = styled.h1`
  margin: 0;
`;

export const Heading2 = styled.h2`
  margin: 0;
`;

export const Heading3 = styled.h3`
  margin: 0;
`;
